/**
 * Matches Flutter `CalendarStreak.advanceAfterPlay` (calendar_streak.dart).
 * Dates are YYYY-MM-DD strings compared via UTC midnight parsing.
 */
function parseDate(yyyyMmDd) {
  const parts = yyyyMmDd.split('-');
  if (parts.length !== 3) throw new Error(`Expected YYYY-MM-DD, got ${yyyyMmDd}`);
  return new Date(Date.UTC(Number(parts[0]), Number(parts[1]) - 1, Number(parts[2])));
}

function formatDateUtc(d) {
  const y = d.getUTCFullYear().toString().padStart(4, '0');
  const m = (d.getUTCMonth() + 1).toString().padStart(2, '0');
  const day = d.getUTCDate().toString().padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function previousDay(yyyyMmDd) {
  const d = parseDate(yyyyMmDd);
  d.setUTCDate(d.getUTCDate() - 1);
  return formatDateUtc(d);
}

/**
 * @param {object} opts
 * @param {string} opts.playDate - YYYY-MM-DD (same convention as Flutter `dateKeyForFirestore`)
 * @param {string|null|undefined} opts.lastPlayed
 * @param {number} opts.currentStreak
 * @returns {{ streak: number, lastPlayed: string }}
 */
export function advanceAfterPlay({ playDate, lastPlayed, currentStreak }) {
  if (lastPlayed === playDate) {
    return { streak: currentStreak, lastPlayed: playDate };
  }
  if (lastPlayed == null || lastPlayed === '') {
    return { streak: 1, lastPlayed: playDate };
  }
  if (lastPlayed === previousDay(playDate)) {
    return { streak: currentStreak + 1, lastPlayed: playDate };
  }
  return { streak: 1, lastPlayed: playDate };
}
